import { render, staticRenderFns } from "./CancelUseCouponDialog.vue?vue&type=template&id=28a58e50&scoped=true"
import script from "./CancelUseCouponDialog.vue?vue&type=script&lang=ts"
export * from "./CancelUseCouponDialog.vue?vue&type=script&lang=ts"
import style0 from "./CancelUseCouponDialog.vue?vue&type=style&index=0&id=28a58e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a58e50",
  null
  
)

export default component.exports